import * as React from "react";

// Types
import Question from "../types/Question.interface";

// Misc.
import { useConditionState } from "../context/Condition.context";
import conditionReducer from "./Condition.lib";

const useProgress = (question: Question | null) => {
  const [progress, setProgress] = React.useState(0);
  const conditionState = useConditionState();

  React.useEffect(() => {
    if (question) {
      const currentlyVisibleStatements = question.statements.filter(
        (statement) => {
          if (statement.conditions && statement.conditions.length > 0) {
            const check = conditionReducer(
              statement.conditions,
              conditionState
            );

            return check;
          }

          return true;
        }
      );

      const conditionCount = currentlyVisibleStatements.filter((statement) => {
        return Object.keys(conditionState).includes(statement._id);
      });
      setProgress(
        (conditionCount.length / currentlyVisibleStatements.length) * 100
      );
    }
  }, [question, conditionState]);

  return [progress];
};

export default useProgress;
